// Opening move: Hook to load canonical test lyrics for consistent testing and demos
// This fixture is used across unit tests, e2e tests, and manual QA to ensure deterministic behavior

import { useState, useEffect } from 'react'
import { CANONICAL_LYRICS_TEXT } from './canonicalLyricsConstants'

export interface CanonicalLyricsOptions {
  // Big play: Load from shared fixture (currently inlined, could load from file in future)
  source?: 'inline' | 'file'
}

/**
 * Hook to load canonical lyrics for testing and demos
 *
 * Main play: Returns the canonical lyrics text with loading state
 * This ensures all tests and demos use the same deterministic content
 * Currently inlined from frontend/fixtures/lyrics/canon-demo.txt
 */
export function useCanonicalLyrics(_options: CanonicalLyricsOptions = {}): {
  lyrics: string
  isLoading: boolean
  error: Error | null
} {
  const [lyrics, setLyrics] = useState<string>('')
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [error, _setError] = useState<Error | null>(null)

  useEffect(() => {
    // Time to tackle the easy bit: load from inlined constant
    // Future enhancement: load from file if needed
    setLyrics(CANONICAL_LYRICS_TEXT)
    setIsLoading(false)
  }, [])

  // Victory lap: return the canonical lyrics with loading state
  return { lyrics, isLoading, error }
}

/**
 * Helper to get canonical lyrics synchronously
 * Use this in tests where you don't need loading state
 */
export function getCanonicalLyrics(): string {
  return CANONICAL_LYRICS_TEXT
}
